import { render, staticRenderFns } from "./PairedListCollectionCreator.vue?vue&type=template&id=501d3026"
import script from "./PairedListCollectionCreator.vue?vue&type=script&setup=true&lang=ts"
export * from "./PairedListCollectionCreator.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PairedListCollectionCreator.vue?vue&type=style&index=0&id=501d3026&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports